<template>
  <KfDesktop>
    <div class="desktop">
      <div style="height: 20px;width: 100%;">
        <Taskbar></Taskbar>
        <Wallpaper style="height: auto;"></Wallpaper>
      </div>
      <div style="max-height: 650px;width: 100%;">
        <div style="text-align: center;height: 250px;">
          <img src="../../public/icon/apps/logo.png" class="zoom-image"/>
        </div>
        <div style="height: 450px;margin-top: 160px">
          <AppGridXjh :user="user"></AppGridXjh>
        </div>

        <!--        <ContextMenu></ContextMenu>-->
        <!--        <NewLockScreen v-if="lock"></NewLockScreen>-->

      </div>
    </div>
  </KfDesktop>
</template>
<script>
import AppGridXjh from "@/views/AppGridXjh.vue";
import NewLockScreen from "@/views/NewLockScreen.vue";

const messages = {
  zhCn: {
    badge_error: 'Badge消息加载失败，{msg}',
  },
  zhTw: {
    badge_error: 'Badge消息加載失敗，{msg}',
  },
  en: {
    badge_error: 'Badge message failed to load, {msg}',
  }
}

export default {
  name: 'Desktop',
  components: {AppGridXjh, NewLockScreen},
  i18n: {messages},
  data() {
    return {
      user: {},
      pollingTimer: null
    }
  },
  async created() {
    await this.loadConfig()

    let user = await this.$http('sysUserService.getCurrentUser');
    this.$store.commit('core/CURRENT_USER_INIT', user)
    await this.loadDefinition()
    await this.getUserApps();

    let data = await this.$http('sysDictService.selectAll')
    this.$store.commit('core/INIT_DICT', data)
  },
  mounted() {
    this.$store.state.core.mobile = false;
  },
  computed: {
    user() {
      return this.$store.state.core.currentUser;
    },
    icons() {
      let icons = []
      this.$store.state.core.applications.forEach(item => {
        icons.push(item)
      })
      return icons;
    },
    sidebarShow() {
      return this.$store.state.core.sidebar;
    },
    lock() {
      return this.$store.state.core.lock;
    }
  },
  methods: {
    polling() {
      let pollingTime = parseInt(this.$store.getters['core/getConfig']('polling_time')) || 0;
      if (pollingTime < 1 || this.pollingTimer) {
        return;
      }

      this.pollingTimer = setInterval(async () => {
        let dataKeys = this.$store.getters['core/getBadgeDataKeyList'];
        if (dataKeys.length == 0) {
          return;
        }

        this.$http('framePollingService.getPollingData', {data_keys: dataKeys}, false).then(data => {
          this.$store.commit('core/INIT_BADGE', data)

          let msg = this.$store.getters['core/getBadgeData']('one_un_send_msg');
          if (msg) {
            this.$notify.info({
              title: "收到新消息",
              message: msg.title,
              duration: 6000
            })
          }
        }, errMsg => {
          return this.$message.error(`Badge消息加载失败，${errMsg}`);
        })
      }, pollingTime * 1000)

    },
    async loadDefinition() {
      let data = await this.$http('frameUiService.loadDefinition')
      this.$store.commit('core/QUERY_DEF_INIT', data.queryList)
      this.$store.commit('core/TABLE_DEF_INIT', data.tableList)
      this.$store.commit('core/FORM_DEF_INIT', data.formList)
    },
    async loadConfig() {
      let data = await this.$http('sysConfigService.getWebConfig')
      this.$store.commit('core/INIT_SYS_CONFIG', data)
      this.$store.commit('wallpaper/INIT_CONFIG', data)
      document.title = this.$store.getters['core/getAppName']

      this.polling()
    },
    async getUserApps() {
      let data = await this.$http('sysUserAppService.getUserApps');
      this.$store.commit('core/INIT_USER_APP', data)
    },


    onClick() {
      this.$store.dispatch('core/selectIcon', this.item.id)
    },
    dblclick() {
      if (this.item.disabled) {
        return this.$message.error(this.$t('AppIcon.no_use', {name: this.item?.name}))
      } else if (this.item?.no_access) {
        return this.$message.error(this.$t('AppIcon.no_access', {name: this.item?.name}))
      }
      if (this.item.link_url) {
        window.open(this.item.link_url, "_blank");
        return;
      }

      let windowObj = {}
      windowObj.icon = this.item.icon;
      windowObj.component = this.item.component
      windowObj.componentParam = this.item.params
      windowObj.name = this.item.name;
      windowObj.badge_data_key = this.item.badge_data_key;
      windowObj.parentData = {
        form_component: this.item?.jsonObj?.form_component,
        show_tips: this.item?.jsonObj?.show_tips ?? false,
      }

      let win = this.item?.jsonObj?.window || {};
      windowObj.width = win.width || this.$store.getters['core/getGlobalWindowWidth']
      windowObj.height = win.height || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.max = win.max || this.$store.getters['core/getGlobalWindowMax']
      // windowObj.max = true
      windowObj.max_icon = win.max_icon
      windowObj.min_icon = win.min_icon

      this.$store.dispatch('core/openWindow', windowObj)

    }

  },
  unmounted() {
    clearInterval(this.pollingTimer)
  }
};
</script>

<style lang="less" scoped>

@media screen and (max-width: 1050px) {
  .desktop {
    height: 100%;
    width: 100%;
    position: absolute;
    //min-height: 650px;
    //min-width: 1024px;
    top: 0;
    left: 0;
  }

  .imgStyle {
    width: 450px;
    height: 248px;
  }
}

.desktop {
  height: 100%;
  width: 100%;
  position: absolute;
  //min-height: 650px;
  //min-width: 1024px;
  top: 0;
  left: 0;
}

.imgStyle {
  width: 450px;
  height: 228px;
}
.zoom-image {
  transform: scale(0.6);
}
</style>
